module.exports = __webpack_public_path__ + "static/media/Cuboid.809288b1.kra";